import React from 'react';
import TranscriptionContainer from './TranscriptionContainer';

const Transcriptions = (props) => (
  <TranscriptionContainer {...props} />
)

export default Transcriptions;


// WEBPACK FOOTER //
// src/routes/Transcriptions/index.js